(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yl-lily-box-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ylbox-builder]').forEach(function(root){
  if(root.dataset.ready){return;} root.dataset.ready='1';
  var selected=[]; var max=8; var maxSame=Number(root.dataset.maxPerChoice||4);
  var count=root.querySelector('[data-count]'); var progress=root.querySelector('[data-progress]');
  var slots=Array.from(root.querySelectorAll('[data-slot]')); var props=Array.from(root.querySelectorAll('[data-property]'));
  var submit=root.querySelector('[data-submit]'); var submitLabel=root.querySelector('[data-submit-label]');
  var summary=root.querySelector('[data-summary]'); var summaryText=root.querySelector('[data-summary-text]'); var error=root.querySelector('[data-error]');
  function message(text){error.hidden=!text;error.textContent=text||'';}
  function add(choice){message(''); if(selected.length>=max){return;} var same=selected.filter(function(x){return x===choice;}).length; if(same>=maxSame){message('Je kunt maximaal '+maxSame+' keer hetzelfde duo kiezen.');return;} selected.push(choice);render();}
  function render(){var remaining=max-selected.length; count.textContent=selected.length; progress.style.width=((selected.length/max)*100)+'%';
    slots.forEach(function(slot,i){var name=selected[i];slot.disabled=!name;slot.querySelector('span').textContent=name||'Leeg';});
    props.forEach(function(input,i){input.value=selected[i]||'';});
    root.querySelectorAll('[data-choice]').forEach(function(btn){var same=selected.filter(function(x){return x===btn.dataset.choice;}).length;btn.disabled=selected.length>=max||same>=maxSame;});
    root.querySelectorAll('[data-add-flavour]').forEach(function(btn){btn.disabled=selected.length>=max;});
    if(remaining===0){summary.textContent='Jouw Lily Box is compleet';summaryText.textContent='Alle 16 creaties zijn gekozen.';submit.disabled=false;submitLabel.textContent='Voeg Lily Box toe';}
    else{summary.textContent='Nog '+remaining+(remaining===1?' duo':' duo\'s')+' kiezen';summaryText.textContent='Vul alle acht plekken om de box te bestellen.';submit.disabled=true;submitLabel.textContent='Kies nog '+remaining+(remaining===1?' duo':' duo\'s');}
  }
  root.querySelectorAll('[data-choice]').forEach(function(btn){btn.addEventListener('click',function(){add(btn.dataset.choice);});});
  root.querySelectorAll('[data-add-flavour]').forEach(function(btn){btn.addEventListener('click',function(){var type=btn.dataset.addFlavour;var select=root.querySelector('[data-flavour="'+type+'"]');var prefix=type==='guimauve'?'Guimauve':'Pâte de fruit';add(prefix+' · '+select.value);});});
  slots.forEach(function(slot){slot.addEventListener('click',function(){var i=Number(slot.dataset.slot);if(i<selected.length){selected.splice(i,1);message('');render();}});});
  root.querySelector('form').addEventListener('submit',function(e){if(selected.length!==max){e.preventDefault();message('Kies eerst alle 8 duo\'s.');}}); render();
});

  } catch(e) { console.error(e); }
})();
})();
